import React, { useContext } from 'react'
import UserContext from 'shared/contexts/user'
import styled, { css } from 'styled-components'
import { DownloadButton } from '../../buttons'
import { DownloadIcon, UploadIcon } from '../../icons'
import { ZoomMakerStatus } from '../../types'
import { ZoomMakerDownloadContext } from './../context'

const Container = styled.div`
    text-align: center;

    button:first-child {
        margin-bottom: 25px;
    }
`

const Secondary = styled.div<{ inactive: boolean }>`
    cursor: pointer;
    display: inline-block;
    font-weight: bold;
    margin: 0 0 40px;
    text-decoration: underline;

    ${props =>
        props.inactive &&
        css`
            opacity: 0.5;
            pointer-events: none;
        `}
`

const ZoomMakerDownloadButtons = () => {
    const { user } = useContext(UserContext)
    const { status, hasDownloaded, onDownload, onUpload } = useContext(ZoomMakerDownloadContext)
    const showUpload = hasDownloaded && user.loggedIn
    const isInactive = status !== ZoomMakerStatus.Idle
    const onPrimaryClick = showUpload ? onUpload : onDownload
    const onSecondaryClick = showUpload ? onDownload : onUpload
    const PrimaryIcon = showUpload ? UploadIcon : DownloadIcon
    return (
        <Container>
            <DownloadButton disabled={isInactive} onClick={onPrimaryClick}>
                <PrimaryIcon />{' '}
                {showUpload ? 'Upload to GIPHY' : hasDownloaded ? 'Download Again' : 'Download your Backdrop'}
            </DownloadButton>
            {user.loggedIn && (
                <Secondary inactive={isInactive} onClick={onSecondaryClick}>
                    {showUpload ? 'Download Again' : 'Upload to GIPHY'}
                </Secondary>
            )}
        </Container>
    )
}

export default ZoomMakerDownloadButtons
